import { z } from "zod";
import { NameSchema, PhoneSchema, UserIdNumberSchema } from "./utils";
import { PasswordSchema } from "./user";
import { ClientEmailSchema, ProfileSchema } from "./profile";

export * from "./user";
export * from "./request";
export * from "./serviceLevel";
export * from "./declaration";
export * from "./doctor";
export * from "./broker";
export * from "./payment";
export * from "./product";
export * from "./pharmacyOrder";
export * from "./lead";
export * from "./task";
export * from "./document";
export * from "./documentVariables";
export * from "./documentTemplate";
export * from "./adminClientData";
export * from "./botConversation";
export * from "./profileLeadStatus";
export * from "./automationVariables";
export * from "./automation";
export * from "./automationExecution";
export { ProfileSchema, newClientSchema } from "./profile";
export type { TNewClient } from "./profile";

export const LoginSchema = z.object({
	email: z.string().email(),
	password: PasswordSchema,
});
export type TLoginForm = z.infer<typeof LoginSchema>;

export const RegisterSchema = ProfileSchema.extend({
	// Optional on the profile, mandatory to sign up with: a self-registered
	// client must be identifiable and reachable from the first minute.
	email: ClientEmailSchema,
	IDNumber: UserIdNumberSchema.transform((str) => str.trim()),
	firstName: NameSchema.transform((str) => str.trim()),
	lastName: NameSchema.transform((str) => str.trim()),
	phone: PhoneSchema.transform((str) => str?.trim()),
	password: PasswordSchema.transform((str) => str.trim()),
	terms: z.literal(true, { message: "אישור תקנון הוא חובה" }),
}).omit({ id: true });

export type TRegisterForm = z.infer<typeof RegisterSchema>;

export type TProfile = z.infer<typeof ProfileSchema>;
